<template>
  <div v-show="show" class="flex-1">
    <hover-button
      class="mx-auto mt-40 lg:mt-64"
      :show-hint="$t('stamp.touch_for_tutorial')"
      breathing
      @click="$emit('next')"
    />
    <panel :height="panelHeight">
      <before-scan />
    </panel>
  </div>
</template>

<script>
import incein from '@/mixins/incein';
import screenWidth from '@/mixins/screen-width';

import Panel from '../../common/Panel.vue';
import BeforeScan from './BeforeScan.vue';
import HoverButton from '../HoverButton.vue';

export default {
  name: 'ThingsToNote3',
  mixins: [screenWidth, incein],
  components: {
    Panel,
    HoverButton,
    BeforeScan,
  },
  props: {
    show: Boolean,
  },
  computed: {
    panelHeight() {
      return this.lg ? '50%' : 581;
    },
  },
};
</script>
